import {LoadingSwitcher} from '@hconnect/uikit'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {spawnErrorToast} from '@hm/fundamental'
import React, {useCallback, FC} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {useInstructionEdit} from '../../hooks/api/useInstructionEdit'
import {useTrackDocumentsAnalytics} from '../../hooks/useTrackDocumentsAnalytics'
import {DocumentUpdate, Instruction} from '../../types/documents.types'

import {DocumentFormContainer} from './DocumentFormContainer'

type DocumentEditProps = {
  plantId: string
  country: string
  doClose: () => void
  onSuccessSubmit: () => void
  document: Instruction
}

export const DocumentEdit: FC<DocumentEditProps> = ({
  plantId,
  country,
  onSuccessSubmit,
  doClose,
  document
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const timezone = useUpmPlantTimezone()
  const trackAnalyticsEvent = useTrackDocumentsAnalytics({plantId, country})
  const editAction = useInstructionEdit({
    plantId,
    timezone,
    options: {
      onSuccess: ({id}) => {
        onSuccessSubmit()
        trackAnalyticsEvent('userEditsInstruction', {instructionId: id})
      },
      onError: () => {
        spawnErrorToast(t('error.failedToUploadFile'))
      }
    }
  })

  const doSubmit = useCallback(
    (item: DocumentUpdate) => {
      editAction.mutate(item)
    },
    [editAction]
  )

  return (
    <LoadingSwitcher isLoading={editAction.isPending}>
      <DocumentFormContainer
        plantId={plantId}
        doClose={doClose}
        doSubmit={doSubmit}
        item={document}
      />
    </LoadingSwitcher>
  )
}
